// Wait for GSAP and CustomEase to load asynchronously
function initButton007() {
  if (typeof gsap === 'undefined' || typeof CustomEase === 'undefined') {
    setTimeout(initButton007, 50);
    return;
  }
  
  // Register GSAP plugins
  gsap.registerPlugin(DrawSVGPlugin, CustomEase);
  try {
    CustomEase.create('button-007-ease', '0.78, 0.18, 0.18, 1');
  } catch(e) {
    // CustomEase already exists
  }

  const buttons = document.querySelectorAll('[data-button-007]');
  if (buttons.length === 0) return;
  
  let mm = gsap.matchMedia();
  
  mm.add('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)', () => {
    buttons.forEach((element, index) => {
      // If already initialized, destroy old instance first to avoid duplicate listeners
      if (element._destroyGSAP) {
        element._destroyGSAP();
      }

      const svgs = element.querySelectorAll('[data-button-007-svg]');
      const paths = element.querySelectorAll('[data-button-007-svg] path');
      const mask = element.querySelector('[data-button-007-mask]');
      const maskObject = element.querySelector('[data-button-007-mask-object]');
      if (svgs.length === 0 || paths.length === 0 || !mask || !maskObject) return;
      
      const hoverRoot = element.closest('[data-hover]') || element;
      const tl = gsap.timeline({ paused: true });
      
      // Use index and timestamp/random to ensure unique mask IDs across sections
      const uniqueId = `button-007-mask-${index}-${Math.random().toString(36).substr(2, 9)}`;
      mask.id = uniqueId;
      maskObject.setAttribute('mask', `url(#${uniqueId})`);
      
      tl.set(paths, {
        drawSVG: '0% 0%',
        strokeWidth: 0,
      });
      
      function syncForeignObjectSize() {
        const parentSvg = svgs[0].parentNode.parentNode;
        if (!parentSvg) return;
        const height = parentSvg.getBoundingClientRect().height;
        if (!height) return;
        maskObject.setAttribute('height', height);
      }
      
      syncForeignObjectSize();
      
      const onWindowResize = () => {
        syncForeignObjectSize();
      };
      
      window.addEventListener('resize', onWindowResize);
      
      let activeTween = null;
      let hoverLocked = false;
      let pendingEnter = false;
      
      const onEnter = () => {
        if (hoverLocked) {
          pendingEnter = true;
          return;
        }
        hoverLocked = true;
        
        if (activeTween) activeTween.kill();
        
        gsap.set(paths, {
          drawSVG: '0% 0%',
          strokeWidth: 0,
        });
        
        activeTween = gsap.to(paths, {
          strokeWidth: strokeWidth,
          drawSVG: '100% 0%',
          duration: 0.8,
          ease: 'button-007-ease',
          overwrite: true,
        });
      };
      
      const onLeave = () => {
        if (activeTween) activeTween.kill();
        pendingEnter = false;
        
        activeTween = gsap.timeline({ overwrite: true });
        
        activeTween.to(paths, {
          strokeWidth: 4,
          duration: 0.8,
          ease: 'button-007-ease',
        }, 0);
        
        activeTween.to(paths, {
          drawSVG: '100% 100%',
          duration: 0.8,
          ease: 'button-007-ease',
        }, 0);
        
        activeTween.call(() => {
          hoverLocked = false;
          if (pendingEnter) {
            pendingEnter = false;
            onEnter();
          }
        }, null, '-=0.2');
      };
      
      const getStrokeWidth = (el) => {
        const value = getComputedStyle(el).getPropertyValue('--button-007-stroke-width').trim();
        return parseFloat(value) || 0;
      };
      const strokeWidth = getStrokeWidth(element);
      
      const onFocusIn = () => {
        if (hoverRoot.matches(':focus-visible')) onEnter();
      };
      const onFocusOut = () => {
        onLeave();
      };
      
      hoverRoot.addEventListener('pointerenter', onEnter);
      hoverRoot.addEventListener('pointerleave', onLeave);
      hoverRoot.addEventListener('focusin', onFocusIn);
      hoverRoot.addEventListener('focusout', onFocusOut);
      
      // Store cleanup function in element to prevent memory leaks in Shopify Customizer
      element._destroyGSAP = () => {
        hoverRoot.removeEventListener('pointerenter', onEnter);
        hoverRoot.removeEventListener('pointerleave', onLeave);
        hoverRoot.removeEventListener('focusin', onFocusIn);
        hoverRoot.removeEventListener('focusout', onFocusOut);
        window.removeEventListener('resize', onWindowResize);
        if (activeTween) activeTween.kill();
        tl.kill();
      };
    });
  });
}

// Initialize on DOM load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(initButton007);
    } else {
      setTimeout(initButton007, 200);
    }
  });
} else {
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(initButton007);
  } else {
    setTimeout(initButton007, 200);
  }
}

// Listen to Shopify Theme Editor Section Load Event
document.addEventListener('shopify:section:load', function(event) {
  initButton007();
});
